import { SET_PAYMENTS } from "../restaurant/constants";

const initState = [];

export default function paymentReducer(state = initState, action) {
  switch (action.type) {
    case SET_PAYMENTS:
      return action.payload;

    default:
      return state;
  }
}
